import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.use(VueAxios, axios)
import store from '~/js/store'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

const productsFilter = new Vue({
    el: '.js-products-filters',
    data: {
        url: CATALOG_FILTERS_URL,
        filterUrl: CATALOG_FILTERS_URL,
        controls: controls,
        productsCount: 0
    },
    methods: {
        getUrl() {
            return this.url;
        },
        getControlsData() {
            let params;
            params = {};

            params['ajax'] = 'y';
            this.controls.forEach((control) => {
                control.items.forEach((item) => {
                  if (item.selected === true) {
                    params[item.controlName] = 'Y';
                  }
                })
            });

            this.axios
                .get(this.getUrl(), {
                  params: params
                })
                .then((response) => {
                  if ((typeof response.data.products === 'object') &&
                    (typeof response.data.products.controls === 'object')
                  )  {
                    this.setControlsData(response.data.products);
                    this.productsCount = response.data.products.productsCount;
                    this.filterUrl = response.data.products.filterUrl.replace(/&amp;/g, '&');
                  }
                });
        },
        setControlValue(propertyId, controlName) {
            this.controls.forEach((control, controlIndex) => {
              if (control.propertyId === propertyId) {
                control.items.forEach((item, valueIndex) => {
                  if (item.controlName == controlName) {
                    this.controls[controlIndex].items[valueIndex]['selected'] = true;
                  } else {
                    this.controls[controlIndex].items[valueIndex]['selected'] = false;
                  }
                });
              }
            });
        },
        setControlsData(data){
            data.controls.forEach((control, controlIndex) => {
              control.items.forEach((item, valueIndex) => {
                this.controls[controlIndex].items[valueIndex].disabled = item.disabled;
              });
            });
        },
        setControlValues(controlName, controlValue){
            let controlObj = new Object();
            controlObj = {
                name: controlName,
                value: controlValue
            }
            this.controls.push(controlObj)
            this.$el.querySelectorAll(".js-filter-range").forEach(control => {
                control.querySelectorAll("input").forEach((el) => {
                    let controlName = `${el.dataset.range}${control.dataset.filter.charAt(0).toUpperCase() + control.dataset.filter.slice(1)}`;
                    let controlValue = el.value;
                    this.setControlValues(controlName, controlValue);
                });
            });
        },
        onFilter(e) {
          let params
          let formData


          params = {}

          formData = new FormData()
          formData.append('filter[ACTIVE]', 'Y')
          this.controls.forEach((control) => {
            control.items.forEach((item) => {
              if (item.selected === true) {
                params[item.controlName] = 'Y'
                formData.append('filter['+control.propertyId+']', item.valueId)
              }
            })
          });


          store.dispatch('getProductItems', formData)

          if (window.innerWidth < 1024) {
            clearAllBodyScrollLocks()
            this.$el.classList.add('hidden')
          }
        },
        reset() {
          window.location.href = this.getUrl()
        }
    },
    mounted(){
        document.addEventListener('select-change', (event) => {
          let propertyId;
          let controlName;
          propertyId = event.detail.propertyid;
          controlName = event.detail.controlname;
          this.setControlValue(propertyId, controlName);
          this.getControlsData();
        });
    }
});
